
import { Options, Vue } from "vue-class-component";

@Options({ props: ["open"] })
export default class Dialog extends Vue {
  closeDialog(): void {
    this.$emit("close");
  }
}
